import { RBACPolicyRole } from '@stytch/core';

export const getRoleDefaultDescription = (role: RBACPolicyRole) => role.description;
